import timg1 from '../images/team/maurice-stoof.jpg'
import timg2 from '../images/team/devon-spijkers.jpg'


const Teams = [
   {
      Id: "1",
      tImg: timg1,
      name: "Maurice Stoof",
      slug: "Maurice-Stoof",
      title: "Co-Founder",
      age: "24 Jaar oud",
      email: "maurice@praeventor.nl",
      mailto: 'mailto:maurice@praeventor.nl',
      phone: "+31 6 27 46 80 33",
      linkedin: "https://www.linkedin.com/in/maurice-stoof-8bb52218a/",
      whatsapp: "Whatsapp link",
      prof_skills: "Mijn professionele vaardigheden omvatten een diepgaande expertise in netwerken, cloudtechnologieën, en effectieve communicatie. Als gedreven professional ben ik gespecialiseerd in cybersecurity, met een bijzondere focus op ethical hacking, automatisering en het ontwerpen van veilige digitale ecosystemen. Ik heb ervaring met het toepassen van innovatieve technieken zoals AI en machine learning om bedreigingen proactief te detecteren en tegen te gaan. Mijn sterke analytische vaardigheden stellen me in staat om complexe beveiligingsproblemen te doorgronden en creatieve oplossingen te ontwikkelen die zowel effectief als schaalbaar zijn.",
      educ_skills: "Ik studeer Cybersecurity & Cloud aan de Hogeschool Utrecht, waar ik me specialiseer in het beveiligen van digitale omgevingen en het toepassen van cutting-edge technologieën om organisaties te beschermen tegen cyberdreigingen. Mijn passie voor ethical hacking en het ontdekken van kwetsbaarheden vormt de kern van mijn academische en professionele groei. Daarnaast heb ik een MBO-opleiding Systeembeheerder afgerond, die me een stevige basis heeft gegeven in IT-infrastructuur en praktische vaardigheden in systeembeheer. Door mijn gecombineerde kennis en ervaring streef ik ernaar een pionier te zijn in het ontwikkelen van innovatieve beveiligingsoplossingen en het bevorderen van een veiliger digitale wereld."
   },
   {
      Id: '2',
      tImg: timg2,
      name: 'Devon Spijkers',
      slug: 'Devon-Spijkers',
      title: 'Co-Founder',
      age: '22 Jaar',
      email: 'devon@praeventor.nl',
      mailto: 'mailto:devon@praeventor.nl',
      phone: '+31 6 43 73 25 19',
      linkedin: 'https://www.linkedin.com/in/devon-spijkers-cyber/',
      whatsapp: 'Whatsapp link',
      prof_skills: 'Ik heb uitgebreide ervaring in netwerken, cloudtechnologieën en communicatie. Ik ben in staat om technische vraagstukken effectief te communiceren en samen te werken binnen diverse IT-omgevingen.',
      educ_skills: 'Ik volg de opleiding Cybersecurity & Cloud aan de Hogeschool Utrecht, waar ik diepgaande kennis verwerf over de nieuwste ontwikkelingen in cybersecurity en cloudinfrastructuren. Daarnaast heb ik mijn MBO in Systeembeheer afgerond, waar ik mijn basiskennis van IT-infrastructuren en systeembeheer heb opgebouwd. Ik pas theoretische concepten toe op praktische problemen en blijf mezelf ontwikkelen in het vakgebied.'

   }

]

export default Teams;